export default (size: number) => `
  height: ${size}px;
  width: ${size}px;
`
